import styled, { css } from 'styled-components';

// ** Utils
import { pxToRem } from 'utils/transform-px.utils';

// ** Styles
import { StyledTextarea } from 'components/textarea/textarea.styled';
import { StyledInputText } from 'components/input-text/input-text.styled';
import { StyledForm } from 'components/form/form.styled';

// ** Components
import { Typography } from 'components';

export const JoinUsStyled = styled.section`
  padding: ${pxToRem(0)} ${pxToRem(130)} ${pxToRem(0)} ${pxToRem(100)};
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        padding: 0;
      `
    )};
`;

export const Inner = styled.div`
  padding: ${pxToRem(56)} ${pxToRem(51)} ${pxToRem(64)};
  background: ${(props) => props.theme.color.silver};
  border-radius: ${(props) => pxToRem(props.theme.borderRadius.high)};
  ${StyledInputText}, ${StyledTextarea} {
    border-color: ${(props) => props.theme.color.softBlack};
    color: ${(props) => props.theme.color.softBlack};
  }
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        padding: ${pxToRem(54)} ${pxToRem(82)} ${pxToRem(50)};
        background: ${(props) => props.theme.color.softBlack};
        border-radius: 0;
        ${StyledInputText}, ${StyledTextarea} {
          border-color: ${(props) => props.theme.color.white};
          color: ${(props) => props.theme.color.white};
        }
        ${StyledForm} {
          max-width: ${pxToRem(404)};
        }
      `
    )};
  ${(props) =>
    props.theme.media.down(
      'sm',
      css`
        padding: ${pxToRem(100)} ${pxToRem(40)};
      `
    )};
`;

export const StyledTitle = styled(Typography)`
  margin-bottom: ${pxToRem(50)};
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        color: ${(props) => props.theme.color.white};
        margin-bottom: ${pxToRem(100)};
      `
    )};
  ${(props) =>
    props.theme.media.down(
      'sm',
      css`
        color: ${(props) => props.theme.color.white};
        margin-bottom: ${pxToRem(50)};
      `
    )};
`;
